export const hasNoFiltersApplied = (filters) => {
  const { from, to, author, tags } = filters;

  const hasNoDateRange = (from === "" || !from) && (to === "" || !to);
  const hasNoAuthor = author === "";
  const hasNoTags = tags.length === 0;

  return hasNoDateRange && hasNoAuthor && hasNoTags;
};

export const isSearchDisabled = (value, filters) => {
  const { categories } = filters;

  const hasNoCategories = categories.length === 0;
  const hasNoSearchValue = value === "";
  const noOtherFiltersApplied = hasNoFiltersApplied(filters);

  return hasNoCategories || (hasNoSearchValue && noOtherFiltersApplied);
};
